import { ArticleStatus } from "entities/manageArticles/types";
import { COLOR_GREEN, COLOR_GREY_3 } from "shared/theme/colors";

export const getChipColor = (status: ArticleStatus) => {
  if (status === ArticleStatus.PUBLISHED) {
    return COLOR_GREEN;
  }

  return COLOR_GREY_3;
};
